import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AppMetaState } from './types';
import { isMaintenanceModeFromServer } from '../../whitelabel';

const initialState: AppMetaState = {
  isMaintenance: isMaintenanceModeFromServer,
  isCloudflareBlocked: false,
};

export const appMetaSlice = createSlice({
  name: 'appMeta',
  initialState,
  reducers: {
    setMaintenanceEnabled: (state, action: PayloadAction<string>) => {
      state.isMaintenance = true;

      // it may come either as a number of seconds or as a date
      if (action.payload && typeof +action.payload === 'number') {
        state.retryAfter = Date.now() + +action.payload * 1000;
      } else if (action.payload) {
        const convertedDate = new Date(action.payload);
        if (+convertedDate) {
          state.retryAfter = convertedDate;
        } else {
          console.error('Invalid retry-after date');
        }
      }

      if (+state.retryAfter < Date.now() - 1000) {
        console.error('Retry after is in the past');
        state.retryAfter = undefined;
      }
    },
    setIsCloudflareBlocked: (state, action: PayloadAction<boolean>) => {
      state.isCloudflareBlocked = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMaintenanceEnabled, setIsCloudflareBlocked } =
  appMetaSlice.actions;

export default appMetaSlice.reducer;
